import React from "react";
import { StyleSheet } from "react-native";
import i18n from "utils/i18n";
import ThemedSafeAreaComponentTop from "components/atoms/ThemedSafeAreaTop";
import ThemedLayout from "components/atoms/ThemedLayout";
import HelperString from "utils/helper-string";
import { useShowHamburger } from 'utils/helper-device'
import TabbedContent from 'components/molecules/TabbedContent'
import ManagementTimeslotsIndexTabTimeslotGroups from './_tabs/TimeslotGroups'
import ManagementTimeslotsIndexTabTimeslotKinds from './_tabs/TimeslotKinds'

const ManagementTimeslotsScene = () => {
	
	const showHamburger = useShowHamburger();
	const tabBarItems = [];

	tabBarItems.push({
		key: 'timeslot_groups',
		text: i18n.t( 'management:pages.timeslots.timeslotGroups.title'),
		scene: ( props ) => {
			return <ManagementTimeslotsIndexTabTimeslotGroups />;
		}
	});
	tabBarItems.push({
		key: 'timeslot_kinds',
		text: i18n.t( 'management:pages.timeslots.timeslotKinds.title'),
		scene: ( props ) => {
			return <ManagementTimeslotsIndexTabTimeslotKinds />;
		}
	});
	
	return (
		<ThemedSafeAreaComponentTop
			top={ false }>
			
			<ThemedLayout
				title={ i18n.t( 'management:pages.timeslots.title')}
				topNavigation={true}
				topNavigationProps={{
					showHamburgerDrawer: showHamburger
				}}>
				
				<TabbedContent
					key={ HelperString.hash('profile-tabs' ) }
					items={ tabBarItems }
				/>
			</ThemedLayout>
		</ThemedSafeAreaComponentTop>
	);
}

const styles = StyleSheet.create({
	column: {
		padding: 20
	},
	subfield: {
		paddingLeft: 20
	},
	subsubfield: {
		paddingLeft: 40
	}
});

export default ManagementTimeslotsScene
